import t from "../../theme";

export const useGetRewardsScreenStyles = () => {
  return {
    pageContainer: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      backgroundColor: "transparent",
    },
    swal: {
      minHeight: 1000,
    },
    titleBanner: {
      height: 50,
      background: "#2e7d32",
      marginBottom: 16,
      display: "flex",
      alignItems: "center",
      padding: "0 40px",
      justifyContent: "space-between",
      color: t.brand.white,
      position: "relative",
      boxShadow: "0 4px 20px rgba(46, 125, 50, 0.25)",
      "& h1": {
        color: "inherit",
        fontSize: "18px",
        fontWeight: 600,
        letterSpacing: "0px",
        margin: 0,
        textShadow: "0 2px 4px rgba(0,0,0,0.1)",
      },
      "@media (max-width: 768px)": {
        height: 44,
        padding: "0 16px",
        "& h1": {
          fontSize: "15px",
        },
      },
    },
    backButtonWrapper: {
      zIndex: 1,
      display: "flex",
      alignItems: "center",
    },
    titlehistory: {
      height: 20,
      background: "#2e7d32",
      marginBottom: 10,
      display: "flex",
      alignItems: "center",
      padding: "0 30px",
      justifyContent: "space-between",
      color: t.brand.white,
      "& h1": {
        color: "inherit",
      },
    },
    detailsWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: 20,
      marginBottom: 20,
      "@media (max-width: 768px)": {
        padding: "0 16px",
      },
    },

    /* ─── Header / Profile Card ─────────────────────────── */
    header: {
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.72) 100%)",
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      display: "flex",
      gap: 32,
      padding: "24px 28px",
      alignItems: "center",
      borderRadius: t.radius.lg,
      border: "1px solid rgba(46, 125, 50, 0.1)",
      boxShadow:
        "0 4px 16px rgba(46, 125, 50, 0.06), 0 1px 3px rgba(0,0,0,0.04)",
      transition: t.transition.smooth,
      position: "relative",
      overflow: "hidden",
      "&:hover": {
        boxShadow:
          "0 6px 20px rgba(46, 125, 50, 0.08), 0 2px 6px rgba(0,0,0,0.05)",
      },
      "@media (max-width: 768px)": {
        flexDirection: "column",
        gap: 16,
        padding: "20px 16px",
        textAlign: "center",
      },
    },
    progressWrapper: {
      flex: 1,
    },
    userTypeTitle: {
      marginBottom: 2,
      fontSize: "14px",
      fontWeight: 600,
      color: t.text.primary,
    },
    progressBarTitle: {
      fontSize: 12,
      color: t.text.muted,
      marginTop: 2,
      marginBottom: 8,
      fontWeight: 500,
    },
    balanceDetails: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 4,
    },
    balanceDetailsTextLight: {
      fontSize: 12,
      color: t.text.muted,
      fontWeight: 500,
      display: "flex",
      gap: 6,
      alignItems: "center",
      "& > span": {
        opacity: 0.7,
      },
    },
    balanceDetailsTextStrong: {
      fontSize: 24,
      color: t.text.primary,
      fontWeight: 700,
      letterSpacing: "-0.5px",
    },
    tandctag: {
      backgroundColor: "rgba(46, 125, 50, 0.06)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      color: t.text.muted,
      padding: "4px 14px",
      fontSize: 11,
      border: "1px solid rgba(46, 125, 50, 0.12)",
      borderRadius: t.radius.pill,
      cursor: "pointer",
      fontWeight: 500,
      transition: t.transition.fast,
      "&:hover": {
        backgroundColor: "rgba(46, 125, 50, 0.12)",
        color: t.text.primary,
      },
    },
    headerActions: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      alignItems: "center",
      "@media (max-width: 768px)": {
        flexDirection: "row",
        gap: 10,
      },
    },
    redeemBtn: {
      maxWidth: 150,
      background: t.green.gradient,
      color: t.brand.white,
      fontSize: 13,
      fontWeight: 600,
      padding: "8px 22px",
      height: 36,
      borderRadius: t.radius.pill,
      border: "none",
      boxShadow: "0 2px 8px rgba(46, 125, 50, 0.3)",
      transition: t.transition.fast,
      cursor: "pointer",
      "&:hover": {
        boxShadow: "0 4px 12px rgba(46, 125, 50, 0.45)",
        transform: "translateY(-1px)",
      },
    },
    noredeemBtn: {
      maxWidth: 150,
      backgroundColor: t.glass.subtle,
      color: t.text.muted,
      fontSize: 13,
      fontWeight: 600,
      padding: "8px 22px",
      height: 36,
      borderRadius: t.radius.pill,
      border: "1px solid rgba(0,0,0,0.06)",
      cursor: "not-allowed",
      opacity: 0.6,
    },

    /* ─── Body / Categories + Content ────────────────────── */
    body: {
      display: "flex",
      borderRadius: t.radius.lg,
      overflow: "hidden",
      border: "1px solid rgba(46, 125, 50, 0.12)",
      boxShadow:
        "0 4px 20px rgba(46, 125, 50, 0.07), 0 1px 4px rgba(0,0,0,0.04)",
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.35) 100%)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      "@media (max-width: 768px)": {
        margin: "0 16px",
        flexDirection: "column",
      },
    },
    leftCategoriesPanel: {
      width: 220,
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.78) 0%, rgba(255,255,255,0.68) 100%)",
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      color: t.text.primary,
      overflow: "auto",
      borderRight: "1px solid rgba(46, 125, 50, 0.1)",
      borderRadius: `${t.radius.lg} 0 0 ${t.radius.lg}`,
      padding: "8px 0",
      alignSelf: "stretch",
      "&::-webkit-scrollbar": {
        width: "4px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: t.green.scrollbar,
        borderRadius: "4px",
      },
      "@media (max-width: 768px)": {
        width: "100%",
        maxHeight: "none",
        borderRight: "none",
        borderBottom: "1px solid rgba(46, 125, 50, 0.1)",
        borderRadius: `${t.radius.lg} ${t.radius.lg} 0 0`,
        padding: "6px 0",
      },
    },
    rightDetailsPanel: {
      display: "flex",
      flexDirection: "column",
      padding: "20px 24px",
      width: "100%",
      gap: 16,
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.5) 100%)",
      backdropFilter: t.blur.medium,
      WebkitBackdropFilter: t.blur.medium,
      "@media (max-width: 768px)": {
        padding: "16px",
      },
    },
    categoryListItem: {
      display: "flex",
      padding: "10px 16px",
      margin: "2px 8px",
      gap: 12,
      alignItems: "center",
      borderRadius: t.radius.md,
      cursor: "pointer",
      transition: t.transition.smooth,
      fontWeight: 500,
      fontSize: "13px",
      color: t.text.secondary,
      border: "1px solid transparent",
      "&:hover": {
        backgroundColor: "rgba(46, 125, 50, 0.06)",
        border: "1px solid rgba(46, 125, 50, 0.1)",
        color: t.text.primary,
      },
      "& img": {
        borderRadius: "6px",
        objectFit: "cover",
        opacity: 0.85,
      },
    },
    selectedcategoryListItem: {
      display: "flex",
      padding: "10px 16px",
      margin: "2px 8px",
      gap: 12,
      alignItems: "center",
      borderRadius: t.radius.md,
      cursor: "pointer",
      background: t.green.gradient,
      color: t.brand.white,
      fontWeight: 600,
      fontSize: "13px",
      position: "relative",
      border: "1px solid rgba(255,255,255,0.15)",
      boxShadow: "0 2px 8px rgba(46, 125, 50, 0.25)",
      transition: t.transition.smooth,
      "& img": {
        borderRadius: "6px",
        objectFit: "cover",
        filter: "brightness(1.1)",
      },
    },
    earnMoneyBtn: {
      maxWidth: 180,
      background: t.green.gradient,
      color: t.brand.white,
      fontSize: 13,
      fontWeight: 600,
      padding: "10px 24px",
      height: 40,
      borderRadius: t.radius.pill,
      border: "none",
      boxShadow: "0 2px 8px rgba(46, 125, 50, 0.3)",
      transition: t.transition.fast,
      cursor: "pointer",
      "&:hover": {
        boxShadow: "0 4px 12px rgba(46, 125, 50, 0.45)",
        transform: "translateY(-1px)",
      },
    },

    /* ─── Accordion ──────────────────────────────────────── */
    accordionWrapper: {
      display: "flex",
      gap: 10,
      flexDirection: "column",
      "& .MuiAccordion-root": {
        background:
          "linear-gradient(135deg, rgba(255,255,255,0.75) 0%, rgba(255,255,255,0.6) 100%)",
        backdropFilter: t.blur.medium,
        WebkitBackdropFilter: t.blur.medium,
        borderRadius: t.radius.md + " !important",
        border: "1px solid rgba(46, 125, 50, 0.1)",
        boxShadow: "0 2px 8px rgba(46, 125, 50, 0.04) !important",
        "&::before": { display: "none" },
        "&:hover": {
          boxShadow: "0 4px 12px rgba(46, 125, 50, 0.08) !important",
        },
      },
      "& .MuiAccordionSummary-root": {
        fontWeight: 600,
        fontSize: "13px",
        minHeight: "44px !important",
        "& .MuiTypography-root": {
          fontSize: "13px",
          fontWeight: 600,
          color: t.text.primary,
        },
      },
      "& .MuiAccordionDetails-root": {
        borderTop: "1px solid rgba(46, 125, 50, 0.06)",
        "& .MuiTypography-root": {
          fontSize: "13px",
          color: t.text.secondary,
          lineHeight: 1.7,
        },
      },
    },

    /* ─── Category Title & Grid ──────────────────────────── */
    catTitle: {
      marginTop: 12,
      marginBottom: 8,
      fontSize: "16px",
      fontWeight: 600,
      color: t.text.primary,
      letterSpacing: "-0.3px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      "&::before": {
        content: '""',
        width: "3px",
        height: "16px",
        background: t.green.gradient,
        borderRadius: "2px",
      },
    },
    categoryView: {
      display: "flex",
      flexWrap: "wrap",
      gap: 20,
      justifyContent: "center",
      alignContent: "flex-start",
      marginTop: 4,
      padding: "20px 16px",
      background: "rgba(255, 255, 255, 0.3)",
      backdropFilter: t.blur.light,
      WebkitBackdropFilter: t.blur.light,
      borderRadius: t.radius.md,
    },
  };
};
